import { ReactNode } from "react";

interface CardProps {
  header: string;
  children: ReactNode;
}
export default function Card({ header, children }: CardProps) {
  return (
    <div className="border h-fit border-border rounded-lg col-span-1">
      <div className="p-5 border-b border-border flex items-center justify-between">
        <div>
          <h1 className="font-semibold text-xl">{header}</h1>
        </div>
      </div>
      <div className="p-5">{children}</div>
    </div>
  );
}
